import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "./store";

const initialState = {
  urlPath: "",
  urlData: null,
  storePath: "",
  basePath: "",
  fullPath: "",
};

const pathSlice = createSlice({
  name: "path",
  initialState,
  reducers: {
    setUrlPath: (state, action) => {
      state.urlPath = action.payload;
    },
    setUrlData: (state, action) => {
      state.urlData = action.payload;
    },
    setStorePath: (state, action) => {
      state.storePath = action.payload;
    },
    setBasePath: (state, action) => {
      state.basePath = action.payload;
    },
    setFullPath: (state, action) => {
      state.fullPath = action.payload;
    },
  },
});

export const getUrlPath = (state: RootState, initialPath: string = "") => {
  return state.path.urlPath || initialPath;
};

export const getUrlData = (state: RootState, initialData: string = null) => {
  return state.path.urlData || initialData;
};

export const getStorePath = (state: RootState, initialPath: string = "") => {
  return state.path.storePath || initialPath;
};

export const getBasePath = (state: RootState, initialPath: string = "") => {
  return state.path.basePath || initialPath;
};

export const getFullPath = (state: RootState, initialPath: string = "") => {
  return state.path.fullPath || initialPath;
};

export const updateFullPath = (pathData: any) => {
  return async (dispatch: any, getState: any) => {
    const { storePath, basePath, fullPath } = pathData;
    dispatch(setStorePath(storePath));
    dispatch(setBasePath(basePath));
    if (fullPath !== undefined) dispatch(setFullPath(fullPath));
  };
};
export const { setUrlPath, setUrlData, setStorePath, setBasePath, setFullPath } =
  pathSlice.actions;
export default pathSlice.reducer;
